<div class="faxe-banner">
  <span class="faxe-banner__app-name" (click)="home()">
    <img class="faxe-banner__logo" src="assets/icons/faxeit.ico" alt="Logo" />
  </span>

  <div class="faxe-banner">
    <span class="faxe-banner__user"></span>
    @if (!viewMode) {
    <span class="faxe-banner__logout" (click)="onAbout()"> Om </span>
    }
  </div>
</div>
